import { apiFetch, apiFetchWithRetry } from '@/lib/apiFetch';
import { handleUnauthorized } from './UserManagmentServices';

export interface StudentProfileSettings {
  waitlistAlerts: boolean;
  weeklyDigest: boolean;
  smsOptIn: boolean;
  allowSearchHistory: boolean;
}

export async function fetchStudentSettings(accessToken: string): Promise<StudentProfileSettings> {
  const response = await apiFetchWithRetry('/api/userManagement/v1/me/settings', {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  if (response.status === 401) handleUnauthorized();
  if (!response.ok) throw new Error(`Failed to fetch student settings: ${response.status}`);
  return response.json();
}

export async function updateStudentSettings(
  accessToken: string,
  patch: Partial<StudentProfileSettings>
): Promise<StudentProfileSettings> {
  const response = await apiFetch('/api/userManagement/v1/me/settings', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(patch),
  });
  if (response.status === 401) handleUnauthorized();
  if (!response.ok) throw new Error(`Failed to update student settings: ${response.status}`);
  return response.json();
}
